import {Component} from '@angular/core';
import {SearchBaseComponent} from '@bbndev/ngx-bbn-zvendo';

@Component({
	selector: 'app-search',
	templateUrl: './search.component.html',
	styleUrls: ['./search.component.scss']
})
export class SearchComponent extends SearchBaseComponent {
}
